import axios from "axios";

import Person from "./Person";

class FiscalCondition extends Person {
  constructor() {
    super();
    this.name = "/condicion_fiscal";
    this.url = this.base_url + this.name;
  }

  grid = async (skip = 0, take = 100, active) => {
    return await axios.get(
      `${this.url}?skip=${skip}&take=${take}&active=${active}`
    );
  };

  select = async () => {
    return await axios.get(`${this.url}/select`);
  };

  changeActive = async (id) => {
    await axios.patch(`${this.url}/${id}`);
  };
}

export default FiscalCondition;
